import type { CityConfig } from "../city-template/types";

export const oskaloosaConfig: CityConfig = {
  city: "Oskaloosa",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "oskaloosa",
  route: "/cities/oskaloosa",
  title: "Emergency Passport Oskaloosa, IA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Oskaloosa, IA — as fast as 24 hours. Serving Mahaska County and Southeast Central Iowa. A+ BBB rated registered State Dept. courier serving William Penn University, Musco Lighting, and Clow Valve professionals. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Oskaloosa, IA",
  heroSubtitle: "Musco Lighting executive with a last-minute sports venue project in Dubai? William Penn University student heading to a study abroad program in Costa Rica and no passport yet? Clow Valve engineer with an urgent site visit to Germany? We help Oskaloosa and Mahaska County residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Oskaloosa%20Iowa%20historic%20downtown%20square%20Mahaska%20County%20courthouse%20brick%20buildings%20tree-lined%20streets%20small%20Midwestern%20city%20at%20golden%20hour%20warm%20sunlight%20professional%20photography%20nostalgic%20Americana%20charm&width=1800&height=700&seq=oskaloosa-hero-ia-2026&orientation=landscape",
  heroImageAlt: "Oskaloosa Iowa historic downtown square and Mahaska County Courthouse at golden hour",
  geoPosition: "41.2928;-92.6438",
  geoPlacename: "Oskaloosa, Iowa",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 300 miles east of Oskaloosa via IA-163/I-80",
  },
  nearbyCitiesZips: [
    { name: "Oskaloosa", zips: "52577" },
    { name: "Pella", zips: "50219" },
    { name: "Knoxville", zips: "50138" },
    { name: "Newton", zips: "50208" },
    { name: "Grinnell", zips: "50112" },
    { name: "Ottumwa", zips: "52501" },
    { name: "Albia", zips: "52531" },
    { name: "Fairfield", zips: "52556" },
    { name: "Sigourney", zips: "52591" },
    { name: "Montezuma", zips: "50171" },
    { name: "Eddyville", zips: "52553" },
    { name: "New Sharon", zips: "50207" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "West Des Moines", zips: "50265, 50266" },
    { name: "Ankeny", zips: "50021, 50023" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Cedar Rapids", zips: "52401–52411" },
    { name: "Marshalltown", zips: "50158" },
    { name: "Indianola", zips: "50125" },
    { name: "Altoona", zips: "50009" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Mahaska County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "SE Central Iowa Coverage", desc: "Serving Oskaloosa, Pella, Ottumwa, and Mahaska County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Pella, IA", route: "/cities/pella" },
    { name: "Fast passport renewal in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Emergency passport help in Ottumwa, IA", route: "/cities/ottumwa" },
    { name: "Urgent passport services in Iowa City, IA", route: "/cities/iowa-city" },
    { name: "Same-day passport help in Newton, IA", route: "/cities/newton-ia" },
    { name: "Passport courier services in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Oskaloosa remotely via secure courier. We do not have a walk-in office in Oskaloosa — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Mahaska County and Southeast Central Iowa.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Mahaska County and Southeast Central Iowa including Keokuk, Wapello, Marion, and Jasper counties",
  serviceAreaIntro: "From the historic downtown square anchored by the Mahaska County Courthouse to the Musco Lighting world headquarters and testing facility, from the William Penn University campus and its Statesmen athletics to the Clow Valve manufacturing plant, from the Nelson Pioneer Farm historic village to the agricultural communities of rural Mahaska County — Fast Passport Center serves the entire Oskaloosa region. We regularly help travelers from Oskaloosa, Pella, Knoxville, Ottumwa, and Newton get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Oskaloosa neighborhoods and the surrounding Southeast Central Iowa area including Pella, Knoxville, Newton, Grinnell, Ottumwa, Albia, and Fairfield. If you are anywhere in Mahaska County, Marion County, or the surrounding region, we have you covered.",
  howItWorksIntro: "Most Oskaloosa travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Mahaska County travelers often face a 5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Oskaloosa and Mahaska County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Oskaloosa? Here are the most common ones we hear from Southeast Central Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Oskaloosa travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Diane W.",
      location: "Oskaloosa, IA",
      rating: 5,
      text: "Musco Lighting had me traveling to Qatar for a stadium lighting project with 5 days notice. Fast Passport Center renewed my passport in 3 days. I didn't even have to leave Oskaloosa. Incredible service.",
      service: "Passport Renewal",
    },
    {
      name: "Trevor M.",
      location: "Oskaloosa, IA",
      rating: 5,
      text: "William Penn study abroad to Costa Rica — I waited too long to apply. Fast Passport Center got my first passport in 4 days. My advisor was shocked. Half the program ended up using them.",
      service: "New Passport",
    },
    {
      name: "Linda and Greg S.",
      location: "New Sharon, IA",
      rating: 5,
      text: "Our anniversary trip to Ireland was in 6 days when we found Greg's passport had expired. Fast Passport Center got it renewed in 4 days. We made our flight and had the trip of a lifetime.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "oskaloosa-1",
      name: "Oskaloosa Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "108 1st Ave E",
      city: "Oskaloosa",
      state: "IA",
      zip: "52577",
      phone: "(641) 673-7071",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Oskaloosa",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Oskaloosa facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "oskaloosa-2",
      name: "Mahaska County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "106 S 1st St",
      city: "Oskaloosa",
      state: "IA",
      zip: "52577",
      phone: "(641) 673-9121",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Oskaloosa Courthouse",
      website: "https://www.mahaskacounty.gov",
      websiteLabel: "Mahaska County Recorder",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "oskaloosa-3",
      name: "Pella Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "703 Main St",
      city: "Pella",
      state: "IA",
      zip: "50219",
      phone: "(641) 628-4021",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles west in Pella",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Marion County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "oskaloosa-4",
      name: "Newton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 1st Ave E",
      city: "Newton",
      state: "IA",
      zip: "50208",
      phone: "(641) 792-4211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles northwest in Newton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Jasper County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "oskaloosa-5",
      name: "Ottumwa Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "310 W 2nd St",
      city: "Ottumwa",
      state: "IA",
      zip: "52501",
      phone: "(641) 682-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles southeast in Ottumwa",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wapello County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Oskaloosa photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Mahaska County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Oskaloosa applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Mahaska County families at the county recorder.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Oskaloosa travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Oskaloosa." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Oskaloosa address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Oskaloosa before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Oskaloosa for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Oskaloosa?", a: "Fast Passport Center offers fast passport renewal in Oskaloosa in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Oskaloosa?", a: "The nearest regional passport agency to Oskaloosa is the Chicago Passport Agency, approximately 300 miles east via IA-163/I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Oskaloosa without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Oskaloosa?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5 hours from Oskaloosa — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Mahaska County residents." },
    { q: "Do you serve the entire Southeast Central Iowa region?", a: "Absolutely. Fast Passport Center serves the entire Southeast Central Iowa region including Oskaloosa, Pella, Knoxville, Newton, Ottumwa, Grinnell, and surrounding communities. Our courier service works seamlessly from any address in Mahaska County and surrounding counties." },
    { q: "Can I expedite a child passport in Oskaloosa?", a: "Yes. Fast Passport Center expedites child passports in Oskaloosa for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Mahaska County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Oskaloosa with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Oskaloosa", address: "2203 A Ave W, Oskaloosa, IA 52577", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Oskaloosa", address: "301 1st Ave E, Oskaloosa, IA 52577", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Pella", address: "1650 Washington St, Pella, IA 50219", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Oskaloosa Driver's License",
      address: "2174 Highway 163, Oskaloosa, IA 52577",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Mahaska County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Knoxville Driver's License",
      address: "1208 N Lincoln St, Knoxville, IA 50138",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Marion County. REAL ID available.",
      featured: false,
    },
    {
      name: "Iowa DOT — Newton Driver's License",
      address: "2112 S 24th Ave W, Newton, IA 50208",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Jasper County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "75 miles west of Oskaloosa",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Iowa's largest airport with direct flights nationwide. About 1 hour 20 minutes from Oskaloosa.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: true,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "85 miles northeast of Oskaloosa",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Regional airport with direct flights to major hubs. About 1 hour 30 minutes from Oskaloosa.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: false,
    },
    {
      code: "OTM",
      name: "Ottumwa Regional Airport",
      distance: "25 miles southeast of Oskaloosa",
      address: "14802 Terminal St, Ottumwa, IA 52501",
      note: "Regional airport with general aviation and charter services. About 30 minutes from Oskaloosa.",
      flightUrl: "https://www.ottumwa.us/departments/airport/",
      flightLabel: "OTM Airport",
      featured: false,
    },
  ],
};